import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import Style from '../updates.module.css'
import { selectCurrentUser, selectIsFirstLogin } from '../../../../features/auth/authSlice'
import { PATH } from '../../../../app/routes'
import { useConnectionCreateAccess } from '../../../../features/clientUsers/useClientAccess'

const firstName = (user) => (user && user.name ? user.name.trim().split(/\s+/)[0] : '')

const WelcomeHero = () => {
    const user = useSelector(selectCurrentUser)
    const isFirstLogin = useSelector(selectIsFirstLogin)
    const name = firstName(user)
    const { canCreate } = useConnectionCreateAccess()

    return (
        <section className={Style.hero} aria-labelledby="updates-title">
            <div className={Style.heroText}>
                <p className={Style.heroEyebrow}>What&apos;s new</p>
                <h1 id="updates-title" className={Style.heroTitle}>
                    {isFirstLogin ? 'Welcome to i95Dev Cloud' : `Welcome back${name ? `, ${name}` : ''}`}
                </h1>
                <p className={Style.heroSubtitle}>
                    Connect your ERP and eCommerce systems, keep an eye on your connectors, and find answers in the knowledge base.
                </p>
            </div>
            <div className={Style.heroActions}>
                {canCreate ? (
                    <Link to={PATH.NEW_CONNECTOR} className={Style.heroPrimary}>
                        <i className="uil-plus" aria-hidden="true" /> New Connector
                    </Link>
                ) : null}
                <Link to={PATH.MARKETPLACE} className={Style.heroSecondary}>
                    Browse Marketplace
                </Link>
            </div>
        </section>
    )
}

export default WelcomeHero
